import { useContextMenu } from "./ContextMenu";
import styles from "./ContextMenuButton.module.css";

function ContextMenuButton({
  leftIcon,
  rightIcon,
  text,
  onClick,
  onMouseDown,
  warning,
  showIcon = true,
  disabled = false,
}) {
  const { closeContextMenu } = useContextMenu();

  return (
    <button
      className={`${styles.button} ${warning ? styles.buttonWarning : ""}`}
      onClick={() => {
        onClick && onClick();
        closeContextMenu();
      }}
      onMouseDown={(e) => {
        e.stopPropagation();
      }}
      disabled={disabled}
    >
      <span
        className={`${warning ? styles.iconWarning : styles.icon}`}
        style={{
          opacity: `${showIcon ? 1 : 0}`,
        }}
      >
        {leftIcon && leftIcon}
      </span>
      <span
        className={styles.text}
        style={{
          paddingLeft: `${leftIcon ? "8px" : ""}`,
        }}
      >
        {text}
      </span>
      <span className={`${warning ? styles.iconWarning : styles.icon}`} style={{ marginLeft: "auto" }}>
        {rightIcon && rightIcon}
      </span>
    </button>
  );
}

export default ContextMenuButton;
